/* className and || '' are essential if I want to also give some other class name to each card */

import './CardContainer.css';

function CardContainer({ children, className }) {
    return (
        <div className={`card-container ${className || ''}`}>
            {children}
        </div>
    );
}

export default CardContainer;